/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { RegistryItemWithOwners } from '../../models/registry-item-with-owners';

export interface RegistryControllerGetOneBySlug$Params {
  slug: string;
}

export function registryControllerGetOneBySlug(http: HttpClient, rootUrl: string, params: RegistryControllerGetOneBySlug$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryItemWithOwners;
}>> {
  const rb = new RequestBuilder(rootUrl, registryControllerGetOneBySlug.PATH, 'get');
  if (params) {
    rb.path('slug', params.slug, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: RegistryItemWithOwners;
      }>;
    })
  );
}

registryControllerGetOneBySlug.PATH = '/registry/slug/{slug}';
